import { motion, AnimatePresence } from "framer-motion";
import { X, LogIn } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const SignInPrompt = ({ open, onClose, title, message }) => {
  const { login } = useAuth();

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center px-5"
          style={{ backgroundColor: "rgba(28, 26, 24, 0.55)" }}
          onClick={onClose}
          data-testid="signin-prompt-overlay"
        >
          <motion.div
            initial={{ opacity: 0, y: 24, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.96 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-md rounded-sm bg-[#FAF9F6] border border-[#D8D3CC] p-8 sm:p-10"
            data-testid="signin-prompt-modal"
          >
            <button
              type="button"
              onClick={onClose}
              className="absolute top-3 right-3 p-1.5 text-[#5C5852] hover:text-[#2C2A28]"
              aria-label="Close"
              data-testid="signin-prompt-close"
            >
              <X size={18} />
            </button>

            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#4A6B53]/10 text-[#4A6B53] mb-4">
              <LogIn size={20} />
            </div>
            <h3 className="font-serif text-2xl sm:text-3xl text-[#2C2A28] leading-tight">
              {title || "Please sign in to continue"}
            </h3>
            <p className="mt-3 text-sm sm:text-base text-[#5C5852] leading-relaxed">
              {message ||
                "Sign in with Google to send a verified note. This helps me keep the inbox a kind place."}
            </p>

            <div className="mt-7 flex flex-col sm:flex-row-reverse gap-3 sm:items-center sm:justify-start">
              <button
                type="button"
                onClick={login}
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-sm bg-[#4A6B53] text-[#FAF9F6] hover:bg-[#3A5441] transition-colors text-sm tracking-wide"
                data-testid="signin-prompt-google-btn"
              >
                <LogIn size={15} />
                Sign in with Google
              </button>
              <button
                type="button"
                onClick={onClose}
                className="text-sm tracking-wide text-[#5C5852] hover:text-[#2C2A28] px-2 py-2.5"
                data-testid="signin-prompt-cancel"
              >
                Not now
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SignInPrompt;
